function cardValidation () {
    var valid = true;
    var name = $('input[name="card_holder_name"]').val();
    var cardNumber = $('input[name="card_number"]').val();
    var month = $('select[name="exp_date_month"] option:selected').val();
    var year = $('select[name="exp_date_year"] option:selected').val();
    var cvc = $('input[name="cvc"]').val();

    if (name.trim() == "") {
        valid = false;
    }
    if (cardNumber.trim() == "") {
    	   valid = false;
    }

    if (month.trim() == "") {
    	    valid = false;
    }
    if (year.trim() == "") {
        valid = false;
    }
    if (cvc.trim() == "") {
        valid = false; 
    }

    if(valid == false) {
       alert("All Fields are required");
    }

    return valid;
}
function UpdateCart($this){
	$.ajax({
		type: "PUT", 
		url: "/cart",
		data: { 
			product_id: $this.data('product'),  
			quantity: $this.val()
		},
		success:function(data){ 
			//$('.show-cart-sidebar').removeClass('show-cart-sidebar');
			if(data.status === 'ok'){
				updateCartTotal(data.amounts.subtotal_formatted);
				updateCartCounter(data.quantity);		
				$('.cart-sidebar-overlay').remove();			
				$('.cart.partial,.partial.order-summary,.check-out.partial').each(function(){
					load_partial($(this));	
				});                
                //actionResponseModal(data.message,'success','.actions-block .save');                
			}else{
				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	});
}

function RemoveFromCart($this){
	$.ajax({
		type: "DELETE", 
		url: "/cart",
		data: { 
			product_id: $this.data('id')
		},
		success:function(data){	
			
			if(data.status === 'ok'){
				updateCartTotal(data.amounts.subtotal_formatted);
				updateCartCounter(data.quantity);                
                $('.cart.partial,.partial.order-summary,.check-out.partial').each(function(){
					load_partial($(this));	
				}); 
			}else{
				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	});
}

function CheckOutStep(data){
	if(data.location){
		window.location = data.location;
		return false;
		
	}else if(data.status === 'ok'){
		
		if(data.step==='confirm'){
			alert('redirect');
		}else{
			$('.check-out-steps li').removeClass('active');
			$('.check-out-steps li[data-step="'+data.next_step+'"]').addClass('active');
			$('.check-out-steps li[data-step="'+data.current_step+'"]').addClass('filled');
			$('.check-out .step').html(data.markup).promise().done(function(){
				 
				$('html,body').animate({ scrollTop: $(".check-out-content").offset().top - $("header").innerHeight() }, '500');
			    skinFormElements('.step');
				load_partial($('.partial.order-summary'));				
			});	
		}
		
	}else{
		actionResponseModal(data.message,'error','.actions-block .save');	
	}				
}


function CheckOutNavStep($this){

	$step = $this.data('step');

	$('.check-out-container').attr('data-step' , $step);
	
	$.ajax({
		type: "POST", 
		url: "/sales/step", 
		data: { 
			step: $step
		},
		success:function(data){		
			
			if(data.status === 'ok'){
				$('.check-out-steps li.active').removeClass('active').addClass('filled');
				$('.check-out-steps li[data-step="'+$this.data('step')+'"]').addClass('active').removeClass('filled');

				$('.check-out .step').html(data.markup).promise().done(function(){
					$('html,body').animate({ scrollTop: 0 }, '500');
				    skinFormElements('.step');
				    $('.next-step').on('click',function(){
				    	if(!$(this).closest('form').parsley().validate()){
				    		return false;
				    	}
				    });
				});


			}else{

				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	});				
}

function AddToCart($this){
	$.ajax({
		type: "POST", 
		url: "/cart", 
		dataType:'json',
		data: { 
			product_id 	: $this.closest('.product-options').find('[name="product_id"]').val(),
			quantity   	: $this.closest('.product-options').find('input[name="quantity"]').val(),
			price   	: $this.closest('.product-options').find('input[name="price"]').val()
		},
		success:function(data){	
			if(data.status === 'ok'){
				if(data.title && data.mpc){
					try{
		                ga('global.send', 'event', 'Products', 'Add to cart', data.title , data.mpc);
		            }catch(Error){}

		            try{
		                ga('local.send', 'event', 'Products', 'Add to cart', data.title , data.mpc);
		            }catch(Error){}
				}


				if($this.closest('.upsales-options-modal').length){
					$('.modal.upsales-options-modal').modal('hide');	
				}

				//console.log(data);
				updateCartTotal(data.amounts.subtotal_formatted);
				updateCartCounter(data.quantity);
                load_partial($('.cart.partial'));	                
				if(data.upsale_modal){
					upsales(data.upsale_data);
				}else{ 
					$('body').addClass('show-cart-sidebar');
				}	 

			}else{
				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	}); 
	return false;
} 


function upsalesFilters($this){
	var $name = $this.attr('name');
	var $value = '["'+$this.val()+'"]';
	var $value = $this.val();
	$('.upsales-partial').data($name,$value);
	load_partial($('.upsales-partial'));	
}


 function updateCartTotal(total_price){
	$('header .summary-value').html(total_price);		
}



function updateCartCounter(quantity){
	if(quantity>99){
		$('header .cart .counter').html('99+');				
	}else{
		$('header .cart .counter').html(quantity);				
	}
	if(quantity > 0){
		$('header .cart').addClass('with-products');
	}else{
		$('header .cart').removeClass('with-products');
	}
}

